

















import Menu from "@/shared/components/menu.vue";
import Bar from "@/shared/components/bar.vue";
import Component from "vue-class-component";
import { Prop, Vue } from "vue-property-decorator";
import { Usuario } from "@/services/home.service";
import { StateMenu } from "../mixins/globalMixin";

import Store from "@/shared/global-store";

@Component({
  components: { Menu, Bar },
})
export default class Mobile extends Vue {
  state = Store.state;

  @Prop({ default: null }) readonly usuario!: Usuario | null;

  mounted() {
    if (document.documentElement.clientWidth <= 1436)
      this.state.drawer = StateMenu.fechado;
  }

  onClick() {
    switch (this.state.drawer) {
      case StateMenu.mini:
        this.state.drawer = StateMenu.fechado;
        break;
      case StateMenu.aberto:
        this.state.drawer = StateMenu.mini;
        break;
      case StateMenu.fechado:
        this.state.drawer = StateMenu.aberto;
        break;
    }
  }
}
